import React, { useEffect } from 'react';
import './CopyrightModal.css';

interface CopyrightModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CopyrightModal: React.FC<CopyrightModalProps> = ({ isOpen, onClose }) => {
  // Данные для компании АБС
  const absData = {
    fullName: "Общество с ограниченной ответственностью «АБС»",
    address: "Россия, 660135, Красноярский край, г. Красноярск, ул. Взлетная, д.7А, пом.164",
    inn: "2466134557",
    okved: "62.01",
    email: "office@kras-abs.ru",
    phone: "+7 (391) 204-08-25",
    website: "www.kras-abs.ru",
    itCodes: "1.01 и 1.02",
    
    // Пункт 9: Описание товаров/услуг и стоимость
    productsDescription: "уточняется",
    
    // Пункт 10: Исключительные права
    hasExclusiveRights: false,
    softwareName: "уточняется",
    registrationNumber: "уточняется",
    registrationDate: "уточняется",
    rightsHolder: "уточняется",
    registryLink: "уточняется",
    
    // Пункт 11: Технологический стек
    programmingLanguages: "уточняется",
    software: "уточняется",
    toolsFrameworks: "уточняется",
    
    // Пункт 12: Реестр российских программ
    inRussianRegistry: false,
    programIdentification: "уточняется",
    distributionMethods: "уточняется"
  };

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        
        <div className="copyright-text">
          <h1>Информация о правообладателе</h1>
          
          <div className="info-section">
            <h2>1. Общие сведения</h2>
            <p>Полное наименование организации: {absData.fullName}</p>
            <p>Адрес организации: {absData.address}</p>
            <p>ИНН налогоплательщика: {absData.inn}</p>
            <p>Основной код по ОКВЭД: {absData.okved}</p>
          </div>
          
          <div className="info-section">
            <h2>2. Контактная информация</h2>
            <p>Адрес электронной почты: <a href={`mailto:${absData.email}`}>{absData.email}</a></p>
            <p>Номер телефона организации: <a href={`tel:${absData.phone.replace(/\s/g, '')}`}>{absData.phone}</a></p>
            <p>Официальный сайт: <a href={`https://${absData.website}`} target="_blank" rel="noopener noreferrer">{absData.website}</a></p>
          </div>
          
          <div className="info-section">
            <h2>3. Деятельность в области ИТ</h2>
            <p>Код (коды) вида (видов) деятельности в области ИТ-технологий: {absData.itCodes}</p>
          </div>
          
          <div className="info-section">
            <h2>4. Описание реализуемых товаров, работ и услуг</h2>
            <p>Описание товаров, работ, услуг и их стоимость: {absData.productsDescription}</p>
          </div>
          
          {/* <div className="info-section">
            <h2>5. Исключительные права на программное обеспечение</h2>
            <p>Наличие исключительных прав: {absData.hasExclusiveRights ? "Да" : "Нет"}</p>
            {absData.hasExclusiveRights && (
              <>
                <p>Название программного продукта: {absData.softwareName}</p>
                <p>Номер регистрации (свидетельства): {absData.registrationNumber}</p>
                <p>Дата регистрации: {absData.registrationDate}</p>
                <p>Правообладатель: {absData.rightsHolder}</p>
                <p>Ссылка на реестр: {absData.registryLink !== "уточняется" ? 
                  <a href={absData.registryLink} target="_blank" rel="noopener noreferrer">{absData.registryLink}</a> : 
                  absData.registryLink}</p>
              </>
            )}
          </div>
          
          <div className="info-section">
            <h2>6. Технологический стек</h2>
            <p>Используемые языки программирования: {absData.programmingLanguages}</p>
            <p>Используемое программное обеспечение: {absData.software}</p>
            <p>Используемые наборы правил и инструментов: {absData.toolsFrameworks}</p>
          </div>
          
          <div className="info-section">
            <h2>7. Реестр российских программ</h2>
            <p>Наличие в едином реестре российских программ: {absData.inRussianRegistry ? "Да" : "Нет"}</p>
            {absData.inRussianRegistry && (
              <>
                <p>Идентификационная информация программы: {absData.programIdentification}</p>
                <p>Способы реализации (распространения) ПО: {absData.distributionMethods}</p>
              </>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};